"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var CheckedM_1 = __importDefault(require("../icons/checked/CheckedM"));
var mixins_1 = require("../style/mixins");
var Checkbox = function (props) {
    var id = props.id, className = props.className, noCheckViaLabel = props.noCheckViaLabel, disabled = props.disabled, children = props.children, field = __rest(props, ["id", "className", "noCheckViaLabel", "disabled", "children"]);
    var checked = field.checked;
    var labelProps = { as: "label", htmlFor: id };
    return (react_1.default.createElement(Container, __assign({ className: className }, (noCheckViaLabel ? {} : labelProps)),
        react_1.default.createElement(OuterBox, __assign({}, (noCheckViaLabel ? labelProps : {})),
            react_1.default.createElement(Input, __assign({}, field, { id: id, disabled: disabled, value: undefined })),
            react_1.default.createElement(Box, { checked: checked, disabled: disabled },
                react_1.default.createElement(CheckedIcon, { visible: checked }))),
        children));
};
exports.Checkbox = Checkbox;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var OuterBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 4px;\n  cursor: pointer;\n"], ["\n  display: inline-block;\n  padding: 4px;\n  cursor: pointer;\n"])));
var Box = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  padding: 2px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n\n  background-color: ", ";\n\n  border: 2px solid;\n  border-color: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  width: 24px;\n  height: 24px;\n  padding: 2px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n\n  background-color: ", ";\n\n  border: 2px solid;\n  border-color: ", ";\n\n  ", "\n\n  ", "\n"])), function (p) { return p.theme.colors.white; }, function (p) { return p.theme.colors.primary; }, function (_a) {
    var checked = _a.checked, _b = _a.theme, colors = _b.colors, mode = _b.mode;
    return checked && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n      border: none;\n    "], ["\n      background-color: ", ";\n      border: none;\n    "])), function () {
        return mode === "Epsy" ? colors.pink : colors.primary;
    });
}, function (_a) {
    var disabled = _a.disabled, colors = _a.theme.colors;
    return disabled && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), colors.grey5);
});
var Input = styled_components_1.default.input.attrs({ type: "checkbox" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), mixins_1.invisible);
var CheckedIcon = (0, styled_components_1.default)(CheckedM_1.default)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  visibility: ", ";\n"], ["\n  color: ", ";\n  visibility: ", ";\n"])), function (p) { return p.theme.colors.white; }, function (props) { return (props.visible ? "visible" : "hidden"); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
